var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevator = function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.116 12.45a1.25 1.25 0 0 1 1.768 0l3.333 3.333a1.25 1.25 0 1 1-1.767 1.768L20 15.1l-2.45 2.45a1.25 1.25 0 1 1-1.767-1.768zM17.55 22.45a1.25 1.25 0 0 0-1.767 1.767l3.333 3.334a1.25 1.25 0 0 0 1.768 0l3.333-3.334a1.25 1.25 0 1 0-1.767-1.767L20 24.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.938 6.27A2.92 2.92 0 0 1 10 5.418h20a2.917 2.917 0 0 1 2.917 2.916v23.333A2.917 2.917 0 0 1 30 34.584H10a2.917 2.917 0 0 1-2.917-2.916V8.333c0-.773.308-1.515.855-2.062M10 7.918a.417.417 0 0 0-.417.416v23.333a.417.417 0 0 0 .417.417h20a.416.416 0 0 0 .417-.416V8.333A.417.417 0 0 0 30 7.916z",
    clipRule: "evenodd"
  })));
};
export default SvgElevator;